import useSWR from 'swr';
import { Line, LineChart, ResponsiveContainer, YAxis } from 'recharts';
import { fetcher } from '../api/client';

interface Point {
  ts: string;
  value: number;
}

interface Props {
  hostId: string;
  name: string;
  env?: string;
  tone: 'ok' | 'warn' | 'crit' | 'muted';
  rangeHours?: number;
  stepSeconds?: number;
}

const TONE_STROKE: Record<Props['tone'], string> = {
  ok: '#10b981',
  warn: '#f59e0b',
  crit: '#ef4444',
  muted: '#94a3b8',
};

export function Sparkline({ hostId, name, env, tone, rangeHours = 24, stepSeconds = 300 }: Props) {
  const from = new Date(Date.now() - rangeHours * 3600 * 1000).toISOString();
  const qs = new URLSearchParams({
    host_id: hostId,
    name,
    from,
    step: String(stepSeconds),
  });
  if (env) qs.set('env', env);
  const key = `/api/metrics/range?${qs.toString()}`;

  const { data } = useSWR<Point[]>(key, fetcher, { refreshInterval: 60_000 });

  if (!data || data.length < 2) {
    return <div className="h-8 w-full" aria-hidden="true" />;
  }

  return (
    <div className="h-8 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
          <YAxis hide domain={['auto', 'auto']} />
          <Line
            type="monotone"
            dataKey="value"
            stroke={TONE_STROKE[tone]}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
